import React, { useContext, useRef, useState, useEffect } from "react";
import "./AddEventModal.css";
import { IoCloseOutline, IoDocumentTextOutline } from "react-icons/io5";
import { TbBrandInstagram, TbStack2, TbWorld } from "react-icons/tb";
import { GrAttachment } from "react-icons/gr";
import { CgCloseO } from "react-icons/cg";
import { useLanguage } from "../../../../LanguageProvider";
import { useToaster } from "../../../../ToasterProvider";
import AddModalInputField from "../../../../components/AddModalInputField/AddModalInputField";
import DatePicker from "../../../../components/DatePicker/DatePicker";
import TimePicker from "../../../../components/TimePicker/TimePicker";
import Dropdown from "../../../../components/Dropdown/Dropdown";
import Services from "../../../../services/Services";
import { GeneralContext } from "../../../../GeneralProvider";
import { RiTwitterXFill } from "react-icons/ri";
import Switch from "../../../../components/Switch/Switch";
import InputField from "../../../../components/InputField/InputField";

export default function AddEventModal({
    isOpen,
    onClose,
    channelID,
    getEvents
}) {
    const token = localStorage.getItem("token")
    const { setCreateProjectLoading } = useContext(GeneralContext);
    const { getTranslation } = useLanguage();
    const { toastWarning, toastSuccess } = useToaster();
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [eventTitle, setEventTitle] = useState("");
    const [eventDescription, setEventDescription] = useState("");
    const [startDate, setStartDate] = useState("");
    const [startTime, setStartTime] = useState("");
    const [endDate, setEndDate] = useState("");
    const [endTime, setEndTime] = useState("");

    const [isOnline, setIsOnline] = useState(false);
    const [locationAddress, setLocationAddress] = useState("");
    const [organizedBy, setOrganizedBy] = useState("");
    const [hasTickets, setHasTickets] = useState(false);
    const [tickets, setTickets] = useState([{ title: "", type: "", description: "", price: "", currency: "TRY", trackInventory: false, inventory: "" }]);
    const [ticketSaleStartDateTime, setTicketSaleStartDateTime] = useState(null);
    const [ticketSaleNotificationEmail, setTicketSaleNotificationEmail] = useState("");
    const [contactEmail, setContactEmail] = useState("");
    const [customerNotificationMailTemplate, setCustomerNotificationMailTemplate] = useState("");
    const [contactPhone, setContactPhone] = useState("");
    const [isOnlineWebsite, setIsOnlineWebsite] = useState("");
    const [website, setWebsite] = useState("");
    const [instagram, setInstagram] = useState("");
    const [x, setX] = useState("");
    const [usersCanSendMessage, setUsersCanSendMessage] = useState(false);
    const [isPublic, setIsPublic] = useState(false);
    const fileInputRef = useRef();
    const [scriptLoaded, setScriptLoaded] = useState(false);
    const [mapOpen, setMapOpen] = useState(false);
    const [latitude, setLatitude] = useState("");
    const [longitude, setLongitude] = useState("");
    const mapRef = useRef(null);
    const mapInstance = useRef(null);
    const markerInstance = useRef(null);
    const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
    const [esAccordionOpen, setEsAccordionOpen] = useState(false);
    const [esShowOnSale, setEsShowOnSale] = useState(true);
    const [esWarnEnabled, setEsWarnEnabled] = useState(true);
    const [esWarnThreshold, setEsWarnThreshold] = useState("50");
    const [esShowParticipantCount, setEsShowParticipantCount] = useState(true);
    const [submitAttempted, setSubmitAttempted] = useState(false);
    const [errors, setErrors] = useState({});



    const computeErrors = () => {
        const e = {};

        // Zorunlu genel alanlar
        if (!eventTitle?.trim()) e.eventTitle = true;
        if (!eventDescription?.trim()) e.eventDescription = true;
        if (!startDate) e.startDate = true;
        if (!startTime) e.startTime = true;
        if (!endDate) e.endDate = true;
        if (!endTime) e.endTime = true;
        if (!organizedBy?.trim()) e.organizedBy = true;
        if (!selectedFiles?.length) e.cover = true;
        if (isOnline) {
            if (!isOnlineWebsite?.trim()) e.isOnlineWebsite = true;
        } else {
            if (!locationAddress?.trim()) e.locationAddress = true;
            if (!latitude || !longitude) e.latlng = true;
        }

        // Biletler açıksa
        if (hasTickets) {
            if (!ticketSaleStartDateTime?.date) e.ticketSaleDate = true;
            if (!ticketSaleStartDateTime?.time) e.ticketSaleTime = true;
            if (!ticketSaleNotificationEmail?.trim()) e.ticketNotifyEmail = true;
            if (!customerNotificationMailTemplate?.trim()) e.ticketCustomerTpl = true;

            tickets.forEach((t, idx) => {
                if (!t.title?.trim()) e[`t${idx}_title`] = true;
                if (!t.type?.trim()) e[`t${idx}_type`] = true;
                if (!t.description?.trim()) e[`t${idx}_desc`] = true;
                if (t.price === "" || t.price === null) e[`t${idx}_price`] = true;
                if (t.trackInventory && (t.inventory === "" || t.inventory === null)) {
                    e[`t${idx}_inv`] = true;
                }
            });
        }

        // Event Settings mantığı: low ticket uyarısı açıksa threshold sayı olmalı
        if (esWarnEnabled) {
            if (esWarnThreshold === "" || isNaN(Number(esWarnThreshold))) {
                e.warnThreshold = true;
            }
        }

        return e;
    };

    useEffect(() => {
        if (submitAttempted) setErrors(computeErrors());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        eventTitle, eventDescription, startDate, startTime, endDate, endTime,
        isOnline, isOnlineWebsite, locationAddress, latitude, longitude,
        organizedBy, hasTickets, tickets, ticketSaleStartDateTime,
        ticketSaleNotificationEmail, customerNotificationMailTemplate,
        esWarnEnabled, esWarnThreshold, selectedFiles
    ]);

    const hasError = (key) => submitAttempted && !!errors[key];

    // Numeric input kontrolü
    const handleEsThresholdChange = (e) => {
        const v = e.target.value;
        if (v === "" || /^[0-9]+$/.test(v)) setEsWarnThreshold(v);
    };

    // Warn, "satışta göster" kapalıyken aktif olmasın
    useEffect(() => {
        if (!esShowOnSale) setEsWarnEnabled(false);
    }, [esShowOnSale]);

    // Settings objesi oluşturucu
    const buildEventSettings = () => ({
        showTicketsOnSale: !!esShowOnSale,
        warnOnLowTickets: !!esWarnEnabled,
        warnThreshold: esWarnEnabled
            ? (esWarnThreshold === "" ? null : parseInt(esWarnThreshold, 10))
            : null,
        showParticipantCount: !!esShowParticipantCount,
    });

    useEffect(() => {
        if (startDate && !endDate) {
            setEndDate(startDate);
        }
    }, [startDate]);

    useEffect(() => {
        if (startTime && !endTime) {
            const [hourStr, minuteStr] = startTime.split(":");
            let hour = parseInt(hourStr, 10);
            let minute = parseInt(minuteStr, 10);

            // 2 saat (120 dakika) ekle
            let totalMinutes = hour * 60 + minute + 120;

            // Maksimum dakika: 23*60 + 45 = 1425 (23:45)
            const maxMinutes = 23 * 60 + 45;
            if (totalMinutes > maxMinutes) {
                totalMinutes = maxMinutes;
            }

            // Yeni saat ve dakika hesapla
            const newHour = Math.floor(totalMinutes / 60);
            const newMinute = totalMinutes % 15 === 0 ? (totalMinutes % 60) : (Math.ceil((totalMinutes % 60) / 15) * 15) % 60;

            const pad = (n) => String(n).padStart(2, "0");
            setEndTime(`${pad(newHour)}:${pad(newMinute)}`);
        }
    }, [startTime]);

    const initMap = () => {
        if (!mapRef.current) return;

        // 1) Harita örneğini oluştur ve sakla
        mapInstance.current = new window.google.maps.Map(mapRef.current, {
            center: { lat: 0, lng: 0 },
            zoom: 2,
        });

        // 2) Marker örneğini oluştur (başlangıçta gizli pozisyonda)
        markerInstance.current = new window.google.maps.Marker({
            map: mapInstance.current,
            position: { lat: 0, lng: 0 },
            visible: false,
        });

        // 3) Haritaya tıklanınca hem state’i hem marker’ı güncelle
        mapInstance.current.addListener("click", (e) => {
            const lat = e.latLng.lat();
            const lng = e.latLng.lng();
            setLatitude(lat);
            setLongitude(lng);

            // Marker’ı göster ve pozisyonunu ayarla
            markerInstance.current.setPosition(e.latLng);
            markerInstance.current.setVisible(true);
        });

        // Eğer daha önce seçilmiş bir koordinat varsa, marker’ı yerleştir
        if (latitude && longitude) {
            const pos = { lat: parseFloat(latitude), lng: parseFloat(longitude) };
            markerInstance.current.setPosition(pos);
            markerInstance.current.setVisible(true);
            mapInstance.current.setCenter(pos);
            mapInstance.current.setZoom(12); // isteğe bağlı zoom ayarı
        }
    };


    useEffect(() => {
        const script = document.createElement("script");
        script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}`;
        script.async = true;
        script.defer = true;
        script.onload = () => {
            setScriptLoaded(true);
            if (mapOpen) initMap();
        };
        document.head.appendChild(script);
    }, []);

    useEffect(() => {
        if (scriptLoaded && mapOpen) {
            initMap();
        }
    }, [scriptLoaded, mapOpen]);

    if (!isOpen) return null;

    const resetStates = () => {
        setErrors({})
        setSubmitAttempted(false)
        setSelectedFiles([]);
        setEventTitle("");
        setEventDescription("");
        setStartDate("");
        setStartTime("");
        setEndDate("");
        setEndTime("");
        setIsOnline(false);
        setLocationAddress("");
        setOrganizedBy("");
        setHasTickets(false);
        setTickets([{ title: "", type: "", description: "", price: "", currency: "TRY", trackInventory: false, inventory: "" }]);
        setTicketSaleStartDateTime(null);
        setTicketSaleNotificationEmail("");
        setContactEmail("");
        setCustomerNotificationMailTemplate("");
        setContactPhone("");
        setWebsite("");
        setInstagram("");
        setX("");
        setUsersCanSendMessage(false);
        setIsPublic(false);
        setIsOnlineWebsite("");
        setMapOpen(false);
        setLatitude("");
        setLongitude("");
        setEsShowOnSale(true);
        setEsWarnEnabled(true);
        setEsWarnThreshold("50");
        setEsShowParticipantCount(true);
        setEsAccordionOpen(false);
    };


    // AddEventModal fonksiyonunuzun en üstüne (useState’lerin altına) ekleyin:
    const allFieldsAreValid = () => {
        // 1. Ana etkinlik alanları
        if (
            !eventTitle ||
            !eventDescription ||
            !startDate ||
            !startTime ||
            !endDate ||
            !endTime ||
            !organizedBy ||
            (isOnline
                ? !isOnlineWebsite
                : !locationAddress)
        ) {
            return false;
        }

        if (!isOnline && (!latitude || !longitude)) {
            return false;
        }

        // 2. Ticket'lar söz konusuysa
        if (hasTickets) {
            // Her bir ticket için alan kontrolleri
            for (const ticket of tickets) {
                if (
                    !ticket.title ||
                    !ticket.type ||
                    !ticket.description ||
                    !ticket.price
                ) {
                    return false;
                }
                // Stok takibi varsa inventory zorunlu
                if (ticket.trackInventory && !ticket.inventory) {
                    return false;
                }
            }
            // 3. Bilet satış zaman ve bildirim ayarları
            if (
                !ticketSaleStartDateTime ||
                !ticketSaleStartDateTime.date ||
                !ticketSaleStartDateTime.time ||
                !ticketSaleNotificationEmail ||
                !customerNotificationMailTemplate
            ) {
                return false;
            }
        }

        // Tüm kontrolleri geçtik
        return true;
    };

    const formatDateTime = (date, time) => {
        const d = typeof date === 'string' ? new Date(date) : new Date(date.toString());
        let hours, minutes;

        // AM/PM varsa ayır
        const hasAMPM = /am|pm/i.test(time);
        if (hasAMPM) {
            const timeMatch = time.match(/^(\d{1,2}):(\d{2})\s?(AM|PM)$/i);
            if (timeMatch) {
                hours = parseInt(timeMatch[1], 10);
                minutes = parseInt(timeMatch[2], 10);
                const meridiem = timeMatch[3].toLowerCase();

                if (meridiem === 'pm' && hours !== 12) hours += 12;
                if (meridiem === 'am' && hours === 12) hours = 0;
            } else {
                console.warn("Time format is not valid:", time);
                return '';
            }
        } else {
            [hours, minutes] = time.split(':').map(Number);
        }

        d.setHours(hours, minutes);

        const pad = (num) => String(num).padStart(2, '0');
        const YYYY = d.getFullYear();
        const MM = pad(d.getMonth() + 1);
        const DD = pad(d.getDate());
        const hh = pad(d.getHours());
        const mm = pad(d.getMinutes());

        return `${YYYY}-${MM}-${DD} ${hh}:${mm}`;
    };


    const createEvent = () => {
        setSubmitAttempted(true);
        const e = computeErrors();
        setErrors(e);
        if (Object.keys(e).length > 0) {
            toastWarning(getTranslation("pleaseFillAllFields"));
            return;
        }
        const settings = buildEventSettings();

        setCreateProjectLoading(true)
        // 1. Kapak (cover) objesi
        const cover = selectedFiles[0]
            ? {
                file: selectedFiles[0].file,
                extension: selectedFiles[0].extension,
            }
            : null;

        // 2. Event başlama / bitiş zamanları
        const eventStartDateTime = formatDateTime(startDate, startTime);
        const eventEndDateTime = formatDateTime(endDate, endTime);

        // 3. Ticket satış zamanı
        const ticketSaleStart = hasTickets
            ? formatDateTime(ticketSaleStartDateTime.date, ticketSaleStartDateTime.time)
            : null;

        // 4. Biletler
        const ticketsPayload = hasTickets ? tickets.map((t) => ({
            title: t.title,
            type: t.type,
            description: t.description,
            price: parseFloat(t.price),
            currency: t.currency,
            trackInventory: t.trackInventory,
            ...(t.trackInventory ? { inventory: parseInt(t.inventory, 10) } : {}),
        })) : [];

        const isFree = !hasTickets
            ? 1
            : ticketsPayload.every((t) => t.price === 0)
                ? 1
                : ticketsPayload.every((t) => t.price > 0)
                    ? 2
                    : 3;

        // 5. Sosyal medya linkleri
        const socialMediaLinks = {
            website,
            instagram,
            x,
        };

        Services.SocialHiveCreateEvent(
            token,
            isFree,
            channelID,
            eventTitle,
            eventDescription,
            cover,
            eventStartDateTime,
            eventEndDateTime,
            isOnline,
            isOnline ? isOnlineWebsite : "",
            isOnline ? "" : locationAddress,
            isOnline ? "" : latitude,
            isOnline ? "" : longitude,
            organizedBy,
            hasTickets,
            ticketsPayload,
            ticketSaleStart,
            contactEmail,
            hasTickets ? ticketSaleNotificationEmail : "",
            customerNotificationMailTemplate,
            contactPhone,
            socialMediaLinks,
            usersCanSendMessage,
            isPublic,
            settings
        )
            .then((res) => {
                setCreateProjectLoading(false)
                if (res.data.status) {
                    toastSuccess(getTranslation("successMessage"));
                    onClose();
                    resetStates();
                    getEvents();
                } else {
                    toastWarning(getTranslation("somethingWentWrong"));
                }
            })
            .catch((err) => {
                console.error(err);
                toastWarning(getTranslation("somethingWentWrong"));
            });
    };

    const addTicketForm = () => {
        setTickets([...tickets, { title: "", type: "", description: "", price: "", currency: "TRY", trackInventory: false, inventory: "" }]);
    };

    const removeTicketForm = (index) => {
        setTickets(tickets.filter((_, i) => i !== index));
    };

    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64String = reader.result.split(",")[1]; // "data:image/jpeg;base64," kısmını kaldırıyoruz
                const extension = file.name.split(".").pop();
                const title =
                    file?.name?.substring(0, file.name.lastIndexOf(".")) || file?.name;
                setSelectedFiles((prevFiles) => [
                    ...prevFiles,
                    { file: base64String, extension: extension, title: title },
                ]);
            };
            reader.readAsDataURL(file);
        });
    };

    const removeFile = (index) => {
        setSelectedFiles((prevFiles) => prevFiles.filter((file, i) => i !== index));
    };

    return (
        <div className="add-event-modal-overlay">
            <div className="add-event-modal-container">
                <IoCloseOutline
                    className="add-event-modal-button close"
                    onClick={() => { onClose(); resetStates(); }}
                />

                <p className="add-event-modal-title">{getTranslation("createEvent")}</p>

                <div style={{ flexDirection: 'row', display: 'flex', alignItems: 'center', gap: '15px' }}>

                    <span
                        className="add-channel-modal-title"
                        onClick={() => { setIsOnline(!isOnline); setMapOpen(false); setLatitude(""); setLongitude(""); }}
                        style={{
                            alignItems: "center",
                            gap: "15px",
                            display: "flex",
                            flexDirection: "row",
                            fontWeight: "500",
                            fontSize: "14px",
                        }}
                    >
                        <input type="checkbox" checked={isOnline} onChange={(e) => { setIsOnline(e.target.checked); setMapOpen(false); setLatitude(""); setLongitude(""); }} />
                        {getTranslation("isOnline")}
                    </span>

                    <span
                        className="add-channel-modal-title"
                        onClick={() => setIsPublic(!isPublic)}
                        style={{
                            alignItems: "center",
                            gap: "15px",
                            display: "flex",
                            flexDirection: "row",
                            fontWeight: "500",
                            fontSize: "14px",
                        }}
                    >
                        <input type="checkbox" checked={isPublic} onChange={(e) => setIsPublic(e.target.checked)} />
                        {getTranslation("isPublic")}
                    </span>

                    {/* <span
                        className="add-channel-modal-title"
                        onClick={() => setUsersCanSendMessage(!usersCanSendMessage)}
                        style={{
                            alignItems: "center",
                            gap: "15px",
                            display: "flex",
                            flexDirection: "row",
                            fontWeight: "500",
                            fontSize: "14px",
                        }}
                    >
                        <input type="checkbox" checked={usersCanSendMessage} onChange={(e) => setUsersCanSendMessage(e.target.checked)} />
                        {getTranslation("usersCanSendMessage")}
                    </span> */}

                </div>


                <div className={hasError("eventTitle") ? "invalid-field" : ""}>
                    <AddModalInputField
                        icon={<TbStack2 size={22} style={{ width: "25px" }} />}
                        placeholder={getTranslation("eventName") + "*"}
                        value={eventTitle}
                        onChange={(e) => setEventTitle(e.target.value)}
                        type="text"
                    />
                </div>

                <div className={`add-task-modal-content ${hasError("eventDescription") ? "invalid-textarea" : ""}`}>
                    <IoDocumentTextOutline
                        size={20}
                        style={{
                            width: "25px",
                            alignSelf: "flex-start",
                            marginTop: "10px",
                        }}
                    />
                    <textarea
                        className={`add-task-modal-textarea`}
                        placeholder={getTranslation("description") + "*"}
                        value={eventDescription}
                        rows={6}
                        onChange={(e) => setEventDescription(e.target.value)}
                    ></textarea>
                </div>

                <div className="add-task-modal-date-time-picker-container">
                    <div className={hasError("startDate") ? "invalid-field" : ""} style={{ width: "100%" }}>
                        <DatePicker
                            style={{ width: "100%" }}
                            buttonStyle={{ width: "100%" }}
                            onDateSelect={setStartDate}
                            toggleLabel={getTranslation("startDate") + "*"}
                        />
                    </div>
                    <div className={hasError("startTime") ? "invalid-field" : ""} style={{ width: "100%" }}>
                        <TimePicker
                            style={{ width: "100%" }}
                            buttonStyle={{ width: "100%" }}
                            onTimeSelect={setStartTime}
                            toggleLabel={getTranslation("startTime") + "*"}
                            quarterIntervals
                        />
                    </div>
                </div>

                <div className="add-task-modal-date-time-picker-container">
                    <div className={hasError("endDate") ? "invalid-field" : ""} style={{ width: "100%" }}>
                        <DatePicker
                            style={{ width: "100%" }}
                            buttonStyle={{ width: "100%" }}
                            onDateSelect={setEndDate}
                            initialDate={endDate}
                            minDate={startDate}
                            toggleLabel={getTranslation("endDate") + "*"}
                        />
                    </div>
                    <div className={hasError("endTime") ? "invalid-field" : ""} style={{ width: "100%" }}>
                        <TimePicker
                            style={{ width: "100%" }}
                            buttonStyle={{ width: "100%" }}
                            onTimeSelect={setEndTime}
                            initialTime={endTime}
                            toggleLabel={getTranslation("endTime") + "*"}
                            quarterIntervals
                        />
                    </div>
                </div>

                {isOnline && (
                    <div className={hasError("isOnlineWebsite") ? "invalid-field" : ""}>
                        <AddModalInputField
                            placeholder={getTranslation("website") + "*"}
                            value={isOnlineWebsite}
                            onChange={(e) => setIsOnlineWebsite(e.target.value)}
                        />
                    </div>
                )}

                {!isOnline && (
                    <>
                        <div className={hasError("locationAddress") ? "invalid-field" : ""}>
                            <AddModalInputField
                                placeholder={getTranslation("locationAddress") + "*"}
                                value={locationAddress}
                                onChange={(e) => setLocationAddress(e.target.value)}
                            />
                        </div>
                        {(latitude && longitude) ? (
                            <span style={{ color: 'var(--add-modal-placeholder-color)', fontWeight: 400 }}>
                                {getTranslation("lat")}: {latitude.toFixed(6)}, {getTranslation("lng")}: {longitude.toFixed(6)}
                            </span>
                        ) : (

                            <span style={{ color: 'var(--add-modal-placeholder-color)', fontWeight: 400 }}>
                                {getTranslation("lat")}*: -, {getTranslation("lng")}*: -
                            </span>
                        )
                        }

                        <div>
                            <button
                                type="button"
                                className={`action-button  ${hasError("latlng") ? "invalid-textarea" : ""}`}
                                style={{ marginTop: '8px' }}
                                onClick={() => setMapOpen(!mapOpen)}
                            >
                                {mapOpen ? getTranslation("hideMap") : getTranslation("showMap")}
                            </button>
                        </div>
                        {mapOpen && (
                            <div className="map-picker-container" style={{ marginTop: '10px' }}>
                                <div
                                    id="map"
                                    ref={mapRef}
                                    style={{ height: '300px', width: '100%' }}
                                />
                            </div>
                        )}
                    </>
                )}


                <div className={hasError("organizedBy") ? "invalid-field" : ""}>
                    <AddModalInputField
                        placeholder={getTranslation("organizedBy") + "*"}
                        value={organizedBy}
                        onChange={(e) => setOrganizedBy(e.target.value)}
                    />
                </div>

                <div
                    className={hasError("cover") ? "invalid-field" : ""}
                    style={{
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: "6px",
                        display: "flex",
                    }}
                >
                    <span
                        style={{
                            width: "100%",
                            flexDirection: "row",
                            alignItems: "center",
                            display: "flex",
                            gap: "5px",
                        }}
                    >
                        <span className="add-event-modal-attachments-icon">
                            <GrAttachment />
                        </span>
                        <span className="add-event-modal-attachments">
                            {getTranslation("uploadBannerImage")}
                        </span>
                    </span>
                    <div className="add-event-modal-select-file-holder">
                        <button
                            className="action-button"
                            onClick={() => fileInputRef.current.click()}
                        >
                            {getTranslation("selectFile")}
                        </button>
                        <input
                            type="file"
                            accept=".png,.jpg,.jpeg,.gif"
                            ref={fileInputRef}
                            style={{ display: "none" }}
                            onChange={handleFileChange}
                        />

                    </div>


                    {/* Seçilen dosyaların chip'lerini gösteren alan */}
                    {selectedFiles.length > 0 && (
                        <div
                            style={{
                                display: "flex",
                                overflowX: "auto",
                                gap: "8px",
                                padding: "8px 0",
                                width: "100%",
                            }}
                        >
                            {selectedFiles.map((file, index) => (
                                <div
                                    className="add-event-modal-added-attachment-chip"
                                    key={index}
                                >
                                    <span className="add-event-modal-added-attachment-chip-title">
                                        {file.title}
                                    </span>
                                    <CgCloseO
                                        onClick={() => removeFile(index)}
                                        style={{
                                            cursor: "var(--pointer)",
                                            minWidth: "14px",
                                            minHeight: "14px",
                                            width: "14px",
                                            height: "14px",
                                        }}
                                    />
                                </div>
                            ))}
                        </div>
                    )}

                </div>

                <AddModalInputField placeholder={getTranslation("contactEmail")} value={contactEmail} onChange={(e) => setContactEmail(e.target.value)} />
                <AddModalInputField placeholder={getTranslation("contactPhone")} value={contactPhone} onChange={(e) => setContactPhone(e.target.value)} />
                <AddModalInputField icon={<TbWorld size={22} style={{ width: "25px" }} />} placeholder={getTranslation("website")} value={website} onChange={(e) => setWebsite(e.target.value)} />
                <AddModalInputField icon={<TbBrandInstagram size={22} style={{ width: "25px" }} />} placeholder={getTranslation("Instagram")} value={instagram} onChange={(e) => setInstagram(e.target.value)} />
                <AddModalInputField icon={<RiTwitterXFill size={20} style={{ width: "25px" }} />} placeholder={getTranslation("X")} value={x} onChange={(e) => setX(e.target.value)} />


                <span
                    className="add-channel-modal-title"
                    style={{
                        alignItems: "center",
                        gap: "15px",
                        display: "flex",
                        flexDirection: "row",
                        fontWeight: "500",
                        fontSize: "14px",
                    }}
                >
                    <input type="checkbox" checked={hasTickets} onChange={(e) => setHasTickets(e.target.checked)} />
                    {getTranslation("hasTickets")}
                    {hasTickets && <button class="sh-ticket-card-btn" style={{ marginLeft: 'auto', width: 'auto', fontSize: '12px', padding: '5px' }} onClick={addTicketForm}>{getTranslation("addTicketType")}</button>}

                </span>

                {hasTickets && (
                    <div>
                        {tickets.map((ticket, index) => (
                            <div key={index} style={{ gap: '15px', display: 'flex', flexDirection: 'column' }}>

                                <div style={{ width: '100%', flexDirection: 'row', display: 'flex', justifyContent: 'space-between', marginTop: '15px' }}>
                                    <Dropdown
                                        style={{ width: "120px" }}
                                        options={[{ value: "TRY", label: "TRY" }]}
                                        onChange={(e) => {
                                            const newTickets = [...tickets];
                                            newTickets[index].currency = e.target.value;
                                            setTickets(newTickets);
                                        }}
                                        value={ticket.currency}
                                    />
                                    <button class="sh-ticket-card-btn" disabled={tickets.length === 1} style={{ backgroundColor: 'transparent' }} onClick={() => removeTicketForm(index)}>-</button>
                                </div>

                                <div className={hasError(`t${index}_title`) ? "invalid-field" : ""}>
                                    <AddModalInputField
                                        placeholder={getTranslation("title") + "*"}
                                        value={ticket.title}
                                        onChange={(e) => {
                                            const newTickets = [...tickets];
                                            newTickets[index].title = e.target.value;
                                            setTickets(newTickets);
                                        }}
                                    />
                                </div>

                                <div className={hasError(`t${index}_type`) ? "invalid-field" : ""}>
                                    <AddModalInputField
                                        placeholder={getTranslation("type") + "*"}
                                        value={ticket.type}
                                        onChange={(e) => {
                                            const newTickets = [...tickets];
                                            newTickets[index].type = e.target.value;
                                            setTickets(newTickets);
                                        }}
                                    />
                                </div>

                                <div className={`add-task-modal-content ${hasError(`t${index}_desc`) ? "invalid-textarea" : ""}`}>
                                    <IoDocumentTextOutline
                                        size={20}
                                        style={{
                                            width: "25px",
                                            alignSelf: "flex-start",
                                            marginTop: "10px",
                                        }}
                                    />
                                    <textarea
                                        className={`add-task-modal-textarea`}
                                        placeholder={getTranslation("description") + "*"} value={ticket.description} onChange={(e) => {
                                            const newTickets = [...tickets];
                                            newTickets[index].description = e.target.value;
                                            setTickets(newTickets);
                                        }} />
                                </div>

                                <div className={hasError(`t${index}_price`) ? "invalid-field" : ""}>
                                    <AddModalInputField
                                        type="number"
                                        placeholder={getTranslation("price") + "*"}
                                        value={ticket.price}
                                        onChange={(e) => {
                                            const newTickets = [...tickets];
                                            newTickets[index].price = e.target.value;
                                            setTickets(newTickets);
                                        }}
                                    />
                                </div>

                                <span
                                    className="add-channel-modal-title"
                                    style={{
                                        alignItems: "center",
                                        gap: "15px",
                                        display: "flex",
                                        flexDirection: "row",
                                        fontWeight: "500",
                                        fontSize: "14px",
                                    }}
                                >
                                    <input type="checkbox" checked={ticket.trackInventory} onChange={(e) => {
                                        const newTickets = [...tickets];
                                        newTickets[index].trackInventory = e.target.checked;
                                        setTickets(newTickets);
                                    }} /> {getTranslation("trackInventory")}
                                </span>

                                <div style={{ marginBottom: '15px' }}>
                                    {ticket.trackInventory &&
                                        <div className={hasError(`t${index}_inv`) ? "invalid-field" : ""} style={{ marginBottom: '15px' }}>
                                            <AddModalInputField
                                                type="number"
                                                placeholder={getTranslation("inventory") + "*"}
                                                value={ticket.inventory}
                                                onChange={(e) => {
                                                    const newTickets = [...tickets];
                                                    newTickets[index].inventory = e.target.value;
                                                    setTickets(newTickets);
                                                }}
                                            />
                                        </div>
                                    }
                                </div>
                            </div>
                        ))}

                        <div className="add-task-modal-date-time-picker-container">
                            <div className={hasError("ticketSaleDate") ? "invalid-field" : ""} style={{ width: "100%" }}>
                                <DatePicker
                                    style={{ width: "100%" }}
                                    buttonStyle={{ width: "100%" }}
                                    onDateSelect={(date) => setTicketSaleStartDateTime({ ...ticketSaleStartDateTime, date })}
                                    toggleLabel={getTranslation("ticketSaleStartDate") + "*"}
                                />
                            </div>
                            <div className={hasError("ticketSaleTime") ? "invalid-field" : ""} style={{ width: "100%" }}>
                                <TimePicker
                                    style={{ width: "100%" }}
                                    buttonStyle={{ width: "100%" }}
                                    onTimeSelect={(time) => setTicketSaleStartDateTime({ ...ticketSaleStartDateTime, time })}
                                    toggleLabel={getTranslation("ticketSaleStartTime") + "*"}
                                />
                            </div>
                        </div>

                        <div className={hasError("ticketNotifyEmail") ? "invalid-field" : ""} style={{ marginTop: '15px' }}>
                            <AddModalInputField
                                placeholder={getTranslation("ticketSaleNotificationEmail") + "*"}
                                value={ticketSaleNotificationEmail}
                                onChange={(e) => setTicketSaleNotificationEmail(e.target.value)}
                            />
                        </div>

                    </div>
                )}

                {hasTickets &&
                    <div className={`add-task-modal-content ${hasError("ticketCustomerTpl") ? "invalid-textarea" : ""}`}>
                        <textarea className={`add-task-modal-textarea`}
                            style={{ height: '250px' }} placeholder={getTranslation("customerNotificationMailTemplate") + "*"} value={customerNotificationMailTemplate} onChange={(e) => setCustomerNotificationMailTemplate(e.target.value)} />
                    </div>
                }

                {/* --- Etkinlik Ayarları (AddEventModal içine, Create butonundan yukarıya) --- */}
                <div>
                    {/* Accordion Header */}
                    <button
                        type="button"
                        className={`sh-es-accordion-header ${esAccordionOpen ? "open" : ""}`}
                        onClick={() => setEsAccordionOpen((v) => !v)}
                        aria-expanded={esAccordionOpen}
                        aria-controls="event-settings-panel"
                    >
                        <span className="sh-es-accordion-title">{getTranslation("configureEventSettings")}</span>
                        <span className="sh-es-accordion-chevron" aria-hidden>
                            {esAccordionOpen ? "▾" : "▸"}
                        </span>
                    </button>

                    {/* Accordion Panel */}
                    {esAccordionOpen && (
                        <div id="event-settings-panel" className="sh-es-accordion-panel">
                            {/* Satışta göster */}
                            <div className="sh-es-row">
                                <span className="sh-es-help">{getTranslation("displayTicketsOnSale")}</span>
                                <Switch
                                    checked={esShowOnSale}
                                    onChange={setEsShowOnSale}
                                    labelLeft={getTranslation("showTicketsOnSale")}
                                    size="sm"
                                />
                            </div>

                            {/* Katılımcı sayısını göster */}
                            <div className="sh-es-row">
                                <span className="sh-es-help">{getTranslation("displayTotalParticipants")}</span>
                                <Switch
                                    checked={esShowParticipantCount}
                                    onChange={setEsShowParticipantCount}
                                    labelLeft={getTranslation("showParticipantCount")}
                                    size="sm"
                                />
                            </div>

                            {/* Düşük bilet uyarısı */}
                            <div className="sh-es-row-inline">
                                <div className="sh-es-col">
                                    <span className="sh-es-help">
                                        {getTranslation("enableLowTicketWarning")}
                                        {!esShowOnSale && (
                                            <em style={{ color: "red", marginLeft: 8 }}>
                                                ({getTranslation("requiresShowTicketsOnSale")})
                                            </em>
                                        )}
                                    </span>
                                    <Switch
                                        checked={esWarnEnabled}
                                        onChange={(val) => {
                                            if (!esShowOnSale && val) return;
                                            setEsWarnEnabled(val);
                                        }}
                                        labelLeft={getTranslation("warnWhenXTicketsLeft")}
                                        size="sm"
                                    />
                                </div>

                                <InputField
                                    type="text"
                                    placeholder={getTranslation("remainingThreshold")}
                                    value={esWarnThreshold}
                                    onChange={handleEsThresholdChange}
                                    style={{
                                        width: 180,
                                        opacity: esWarnEnabled ? 1 : 0.6,
                                        pointerEvents: esWarnEnabled ? "auto" : "none",
                                    }}
                                />
                            </div>
                        </div>
                    )}
                </div>

                <button
                    className="add-event-modal-button create"
                    onClick={createEvent}
                >
                    {getTranslation("create")}
                </button>

            </div>
        </div>
    );
}
